import { useEffect, useState } from 'react';
import api from '../api/axios';
import styles from './Table.module.css';

export default function Interests() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const fetch = async (p = 1) => {
    setLoading(true);
    try {
      const res = await api.get(`/interest/admin?page=${p}&limit=20`);
      setItems(res.data.interests);
      setTotal(res.data.total);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetch(page); }, [page]);

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this entry?')) return;
    await api.delete(`/interest/admin/${id}`);
    fetch(page);
  };

  const fmt = (price) =>
    Number(price).toLocaleString('en-PK', { maximumFractionDigits: 0 });

  const pages = Math.ceil(total / 20);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2 style={{ margin: 0 }}>Interests ({total})</h2>
      </div>

      {loading ? <p>Loading...</p> : (
        <div className={styles.tableWrap}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Ad Title</th>
                <th>Category</th>
                <th>Price</th>
                <th>City</th>
                <th>Phone</th>
                <th>Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 && (
                <tr><td colSpan={7} style={{ textAlign: 'center', color: '#999', padding: 40 }}>No interests yet</td></tr>
              )}
              {items.map(item => (
                <tr key={item._id}>
                  <td style={{ fontWeight: 600, maxWidth: 200 }}>
                    {item.ad?.title || <span style={{ color: '#ccc' }}>Deleted ad</span>}
                  </td>
                  <td>{item.ad?.category?.name || '—'}</td>
                  <td style={{ color: '#6CA651', fontWeight: 700 }}>
                    {item.ad?.price ? `₹ ${fmt(item.ad.price)}` : '—'}
                  </td>
                  <td>{item.ad?.city || '—'}</td>
                  <td>
                    <a href={`tel:${item.phone}`} style={{ color: '#E8192C', fontWeight: 700, textDecoration: 'none' }}>
                      {item.phone}
                    </a>
                  </td>
                  <td style={{ whiteSpace: 'nowrap', color: '#888', fontSize: 13 }}>
                    {new Date(item.createdAt).toLocaleString('en-PK', {
                      day: '2-digit', month: 'short', year: 'numeric',
                      hour: '2-digit', minute: '2-digit',
                    })}
                  </td>
                  <td>
                    <button className={styles.deleteBtn} onClick={() => handleDelete(item._id)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {pages > 1 && (
        <div style={{ display: 'flex', gap: 8, marginTop: 16, justifyContent: 'center' }}>
          {Array.from({ length: pages }, (_, i) => i + 1).map(p => (
            <button key={p} onClick={() => setPage(p)} style={{
              padding: '4px 12px', borderRadius: 6, border: '1px solid #ddd',
              background: p === page ? '#6366f1' : '#fff',
              color: p === page ? '#fff' : '#333', cursor: 'pointer',
            }}>{p}</button>
          ))}
        </div>
      )}
    </div>
  );
}
